(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  class UgcStories extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      const dataEl = this.querySelector('.ugc-stories__data');
      try {
        this.stories = JSON.parse(dataEl.textContent);
      } catch (e) {
        this.stories = [];
      }
      this.showNames = this.dataset.showNames === 'true';
      this.index = 0;
      this.paused = false;
      this.holdTimer = null;
      this.rafId = null;
      this.lastTs = 0;
      this.elapsed = 0;
      this.muted = true;

      this.querySelectorAll('[data-ugc-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(parseInt(btn.dataset.ugcOpen, 10)));
      });
    }

    buildPlayer() {
      if (this.player) return;
      const el = document.createElement('div');
      el.className = 'ugc-player is-muted';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Історії покупців');
      el.innerHTML = `
        <div class="ugc-player__stage">
          <video class="ugc-player__media" playsinline muted preload="none" hidden></video>
          <div class="ugc-player__poster" hidden></div>
          <div class="ugc-player__scrim"></div>
          <div class="ugc-player__progress" aria-hidden="true"></div>
          <div class="ugc-player__top">
            <img class="ugc-player__avatar" alt="">
            <span class="ugc-player__author"></span>
            <button type="button" class="ugc-player__btn ugc-player__btn--mute" aria-label="Звук">
              <svg class="ugc-player__icon--muted" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>
              <svg class="ugc-player__icon--unmuted" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>
            </button>
            <button type="button" class="ugc-player__btn ugc-player__close" aria-label="Закрити">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>
          <div class="ugc-player__nav">
            <button type="button" class="ugc-player__zone ugc-player__zone--prev" aria-label="Попередня історія" tabindex="-1"></button>
            <button type="button" class="ugc-player__zone ugc-player__zone--next" aria-label="Наступна історія" tabindex="-1"></button>
          </div>
          <button type="button" class="ugc-player__arrow ugc-player__arrow--prev" aria-label="Попередня історія">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
          </button>
          <button type="button" class="ugc-player__arrow ugc-player__arrow--next" aria-label="Наступна історія">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
          </button>
          <a class="ugc-player__cta" href="#" hidden></a>
        </div>`;
      document.body.appendChild(el);

      this.player = el;
      this.stage = el.querySelector('.ugc-player__stage');
      this.video = el.querySelector('.ugc-player__media');
      this.poster = el.querySelector('.ugc-player__poster');
      this.progress = el.querySelector('.ugc-player__progress');
      this.avatar = el.querySelector('.ugc-player__avatar');
      this.authorEl = el.querySelector('.ugc-player__author');
      this.ctaEl = el.querySelector('.ugc-player__cta');
      this.muteBtn = el.querySelector('.ugc-player__btn--mute');

      // Build one progress segment per story.
      this.progress.innerHTML = this.stories
        .map(() => '<span class="ugc-player__seg"><span class="ugc-player__seg-fill"></span></span>')
        .join('');
      this.segs = Array.from(this.progress.querySelectorAll('.ugc-player__seg-fill'));

      // Wire controls.
      el.querySelector('.ugc-player__close').addEventListener('click', () => this.close());
      el.querySelector('.ugc-player__zone--prev').addEventListener('click', () => this.prev());
      el.querySelector('.ugc-player__zone--next').addEventListener('click', () => this.next());
      el.querySelector('.ugc-player__arrow--prev').addEventListener('click', () => this.prev());
      el.querySelector('.ugc-player__arrow--next').addEventListener('click', () => this.next());
      this.muteBtn.addEventListener('click', () => this.toggleMute());

      // Desktop: click dimmed backdrop (around the phone frame) to close.
      el.addEventListener('click', (e) => {
        if (e.target !== el) return;
        if (window.matchMedia('(min-width: 750px)').matches) this.close();
      });

      this.video.addEventListener('ended', () => {
        this._trackUgcComplete();
        this.next();
      });
      this._ugcMarks = {};
      this.video.addEventListener('play', () => {
        if (this._ugcPlayStarted) return;
        this._ugcPlayStarted = true;
        this._ugcMarks = {};
        if (typeof window.bosiTrack === 'function') {
          window.bosiTrack('video_start', { media_type: 'video', surface: 'ugc' });
        }
      });
      this.video.addEventListener('timeupdate', () => {
        var d = this.video.duration;
        if (!d || !Number.isFinite(d)) return;
        var pct = (this.video.currentTime / d) * 100;
        [25, 50, 75, 95].forEach((mark) => {
          if (pct >= mark && !this._ugcMarks[mark]) {
            this._ugcMarks[mark] = true;
            if (typeof window.bosiTrack === 'function') {
              window.bosiTrack('video_progress', { percent: mark, surface: 'ugc' });
            }
          }
        });
      });

      // Press-and-hold to pause (ignore chrome controls / CTA / arrows).
      const holdStart = (e) => {
        if (e.target.closest('.ugc-player__btn, .ugc-player__cta, .ugc-player__arrow, a')) {
          return;
        }
        this.pointerStartY = e.clientY;
        this.pointerStartX = e.clientX;
        this.swiping = false;
        this.holdTimer = setTimeout(() => this.pause(), 220);
      };
      const holdEnd = () => {
        clearTimeout(this.holdTimer);
        if (this.paused) this.resume();
      };
      this.stage.addEventListener('pointerdown', holdStart);
      this.stage.addEventListener('pointerup', holdEnd);
      this.stage.addEventListener('pointercancel', holdEnd);

      // Swipe down to close.
      this.stage.addEventListener('pointermove', (e) => {
        if (this.pointerStartY == null) return;
        const dy = e.clientY - this.pointerStartY;
        const dx = Math.abs(e.clientX - this.pointerStartX);
        if (dy > 12 && dy > dx) {
          this.swiping = true;
          this.stage.style.transform = `translateY(${Math.min(dy, 260)}px)`;
          this.stage.style.opacity = String(Math.max(1 - dy / 400, 0.3));
        }
      });
      this.stage.addEventListener('pointerup', (e) => {
        if (this.pointerStartY != null) {
          const dy = e.clientY - this.pointerStartY;
          if (this.swiping && dy > 120) {
            this.close();
          } else {
            this.stage.style.transform = '';
            this.stage.style.opacity = '';
          }
        }
        this.pointerStartY = null;
      });

      this._keyHandler = (e) => {
        if (!this.player.classList.contains('is-open')) return;
        if (e.key === 'Escape') this.close();
        else if (e.key === 'ArrowRight') this.next();
        else if (e.key === 'ArrowLeft') this.prev();
        else if (e.key === 'Tab') this.trapFocus(e);
      };
      document.addEventListener('keydown', this._keyHandler);
    }

    open(index) {
      this.buildPlayer();
      this.index = Math.max(0, Math.min(index, this.stories.length - 1));
      this.lastFocused = document.activeElement;
      this.player.classList.add('is-open');
      this.lockScroll(true);
      this.render();
      // Move focus into the dialog for keyboard users.
      this.player.querySelector('.ugc-player__close').focus();
      if (typeof window.bosiTrack === 'function') {
        var opened = this.stories[this.index] || {};
        window.bosiTrack('ugc_story_open', {
          story_index: this.index + 1,
          author: opened.author || '',
          surface: 'pdp',
        });
      }
    }

    close() {
      if (!this.player) return;
      this.stopTick();
      this.video.pause();
      this.video.removeAttribute('src');
      this.video.load();
      this.player.classList.remove('is-open');
      this.stage.style.transform = '';
      this.stage.style.opacity = '';
      this.lockScroll(false);
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
    }

    render() {
      const story = this.stories[this.index];
      if (!story) return this.close();

      // Progress state: past = full, future = empty, current handled by tick.
      this.segs.forEach((seg, i) => {
        seg.style.width = i < this.index ? '100%' : '0%';
      });

      this.authorEl.textContent = story.author || '';
      const avatarSrc = story.avatar || story.thumb || story.poster;
      if (avatarSrc) {
        this.avatar.src = avatarSrc;
        this.avatar.hidden = false;
      } else {
        this.avatar.hidden = true;
      }

      // CTA (optional, per story).
      if (story.ctaLabel && story.ctaLink) {
        this.ctaEl.textContent = story.ctaLabel;
        this.ctaEl.href = story.ctaLink;
        this.ctaEl.hidden = false;
      } else {
        this.ctaEl.hidden = true;
      }

      this.elapsed = 0;
      this.lastTs = 0;
      this.paused = false;

      if (story.video) {
        // Real video path — plays muted-autoplay by default, playsinline.
        this._ugcPlayStarted = false;
        const playToken = (this._playToken = (this._playToken || 0) + 1);
        this.poster.hidden = true;
        this.video.hidden = false;
        this.video.poster = story.poster || '';
        this.video.muted = this.muted;
        // Reset previous source cleanly to avoid race on rapid next/prev.
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.video.src = story.video;
        const playPromise = this.video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {
            if (playToken !== this._playToken) return;
            // Autoplay blocked: force muted and retry.
            this.video.muted = true;
            this.muted = true;
            this.player.classList.add('is-muted');
            this.video.play().catch(() => {});
          });
        }
        this.mode = 'video';
        this.muteBtn.hidden = false;
      } else {
        // Poster-only path — timed auto-advance.
        this.video.hidden = true;
        this.video.removeAttribute('src');
        this.poster.hidden = false;
        this.poster.style.backgroundImage = story.poster ? `url("${story.poster}")` : 'none';
        this.mode = 'image';
        this.durationMs = (story.duration || 5) * 1000;
        this.muteBtn.hidden = true;
      }

      this.startTick();
    }

    startTick() {
      this.stopTick();
      const step = (ts) => {
        if (!this.lastTs) this.lastTs = ts;
        if (this.paused) {
          this.lastTs = ts;
          this.rafId = requestAnimationFrame(step);
          return;
        }
        let frac;
        if (this.mode === 'video') {
          const d = this.video.duration;
          // Until metadata loads, duration is NaN — keep segment at 0, don't advance.
          if (!d || !Number.isFinite(d)) {
            frac = 0;
          } else {
            frac = this.video.currentTime / d;
          }
        } else {
          this.elapsed += ts - this.lastTs;
          frac = this.elapsed / this.durationMs;
        }
        this.lastTs = ts;
        frac = Math.max(0, Math.min(frac, 1));
        if (this.segs[this.index]) this.segs[this.index].style.width = frac * 100 + '%';
        if (frac >= 1) {
          this._trackUgcComplete();
          this.next();
          return;
        }
        this.rafId = requestAnimationFrame(step);
      };
      this.rafId = requestAnimationFrame(step);
    }

    stopTick() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    pause() {
      this.paused = true;
      if (this.mode === 'video') this.video.pause();
    }

    resume() {
      this.paused = false;
      this.lastTs = 0;
      if (this.mode === 'video') this.video.play().catch(() => {});
    }

    _trackUgcComplete() {
      if (this._completedIndex === this.index) return;
      this._completedIndex = this.index;
      if (typeof window.bosiTrack !== 'function') return;
      var story = this.stories[this.index] || {};
      window.bosiTrack('ugc_story_complete', {
        story_index: this.index + 1,
        author: story.author || '',
        surface: 'pdp',
      });
      if (this.mode === 'video') {
        window.bosiTrack('video_complete', { surface: 'ugc' });
      }
    }

    next() {
      if (this.index >= this.stories.length - 1) {
        this.close();
        return;
      }
      if (this.segs[this.index]) this.segs[this.index].style.width = '100%';
      this.index += 1;
      this.render();
      if (typeof window.bosiTrack === 'function') {
        var nxt = this.stories[this.index] || {};
        window.bosiTrack('ugc_story_open', {
          story_index: this.index + 1,
          author: nxt.author || '',
          surface: 'pdp',
        });
      }
    }

    prev() {
      if (this.index <= 0) {
        this.render();
        return;
      }
      if (this.segs[this.index]) this.segs[this.index].style.width = '0%';
      this.index -= 1;
      this.render();
    }

    toggleMute() {
      this.muted = !this.muted;
      this.video.muted = this.muted;
      this.player.classList.toggle('is-muted', this.muted);
      if (!this.muted) this.video.play().catch(() => {});
    }

    lockScroll(lock) {
      if (lock) {
        this.scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.width = '100%';
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        if (this.scrollY != null) window.scrollTo(0, this.scrollY);
      }
    }

    trapFocus(e) {
      const focusable = this.player.querySelectorAll(
        'button:not([tabindex="-1"]):not([hidden]), a[href]:not([hidden])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('ugc-stories')) {
    customElements.define('ugc-stories', UgcStories);
  }

  } catch(e) { console.error(e); }
})();
})();
